<mat-dialog-content>
    <span mat-dialog-title style="margin: 0px;">Ihre Nachricht</span>


    <ng-container *ngIf="!data.onlyText">
        <mat-checkbox [(ngModel)]="data.notiz.pinned">Angepinnt</mat-checkbox>
        <mat-checkbox [(ngModel)]="data.notiz.important">
            Wichtig
        </mat-checkbox>
    </ng-container>
    <mat-form-field class="full-width" style="width: 100%">
        <textarea matInput placeholder="Text" rows="8" maxrows="50" [(ngModel)]="data.notiz.text"></textarea>
    </mat-form-field>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button mat-button mat-dialog-close tabindex="-1"><span>Abbrechen</span></button>
    <button color="primary" mat-flat-button mat-button [disabled]="!data.notiz.text"
        (click)="saveNotiz()" type="submit"><span>Speichern</span></button>
</mat-dialog-actions>